<template>
  <div v-if="attiva && visibilePagina" class="cyb-chat" :style="{ '--chat-color': $theme.basecolor, '--chat-fore': $theme.basefore || '#ffffff' }">
    <!-- ______________________ PULSANTE E INVITO ______________________ -->
    <template v-if="!aperta">
      <!-- risposta arrivata a chat chiusa -->
      <button v-if="nonLetti" type="button" class="chat-invito chat-nonletto shadow" @click="apri">
        <b>{{ testi.CHAT_Assistente }}</b>
        <span>{{ anteprima }}</span>
      </button>
      <div v-else-if="invito" class="chat-invito shadow">
        <button type="button" class="chat-invito-testo" @click="apri">{{ testi.CHAT_Invito }}</button>
        <button type="button" class="chat-invito-chiudi" :title="testi.CHAT_Chiudi" @click="chiudiInvito"><fa :icon="['fas', 'times']" /></button>
      </div>
      <button type="button" class="chat-apri shadow" :title="messaggi.length ? testi.CHAT_Torna : testi.CHAT_Apri" @click="apri">
        <fa :icon="['fas', 'comments']" />
        <span class="chat-apri-testo">{{ messaggi.length ? testi.CHAT_Torna : testi.CHAT_Apri }}</span>
        <span v-if="nonLetti" class="chat-contatore">{{ nonLetti }}</span>
      </button>
    </template>

    <!-- ______________________ FINESTRA ______________________ -->
    <div v-else class="chat-finestra shadow" role="dialog" :aria-label="testi.CHAT_Titolo" :style="stileFinestra">
      <div class="chat-testata">
        <div :class="['chat-avatar', $hotel.logo ? 'con-logo' : '']">
          <img v-if="$hotel.logo" :src="$hotel.logo" alt="" />
          <span v-else>{{ iniziali }}</span>
        </div>
        <div class="chat-titolo">
          <div class="chat-nome">{{ $hotel.ragsoc || testi.CHAT_Titolo }}</div>
          <div class="chat-stato"><i class="chat-puntino"></i>{{ testi.CHAT_Online }}</div>
        </div>
        <button type="button" class="chat-icona" :title="testi.CHAT_Nuova" @click="nuova"><fa :icon="['fas', 'redo-alt']" /></button>
        <button type="button" class="chat-icona" :title="testi.CHAT_Chiudi" @click="aperta = false"><fa :icon="['fas', 'times']" /></button>
      </div>

      <div ref="messaggi" class="chat-messaggi">
        <!-- Avviso obbligatorio (AI Act e privacy): una riga, il testo intero a richiesta -->
        <div class="chat-avviso">
          <p class="chat-avviso-testo"><fa :icon="['fas', 'info-circle']" /> {{ testi.CHAT_InfoBreve }}</p>
          <!-- i due link sempre sulla stessa riga -->
          <div class="chat-avviso-link">
            <button type="button" class="chat-link" :aria-expanded="avvisoAperto ? 'true' : 'false'" @click="avvisoAperto = !avvisoAperto">{{ testi.CHAT_Dettagli }}</button>
            <template v-if="privacy">
              <span aria-hidden="true">·</span>
              <button type="button" class="chat-link" :aria-expanded="privacyAperta ? 'true' : 'false'" @click="privacyAperta = !privacyAperta">{{ testi.Privacy }}</button>
            </template>
          </div>
        </div>
        <div v-if="avvisoAperto" class="chat-avviso-intero">{{ testi.CHAT_Avviso }}</div>
        <!-- l'informativa dell'hotel, la stessa del form di prenotazione (HTML scritto dall'hotel) -->
        <!-- eslint-disable-next-line vue/no-v-html -->
        <div v-if="privacyAperta" class="chat-avviso-intero chat-privacy" v-html="privacy"></div>

        <div class="chat-msg bot"><div class="chat-fumetto">{{ testi.CHAT_Benvenuto }}</div></div>
        <!-- domande rapide: solo a chat vuota, poi niente suggerimenti -->
        <div v-if="!messaggi.length" class="chat-rapide">
          <button v-for="d in rapide" :key="d" type="button" class="chat-rapida" @click="chiedi(d)">{{ d }}</button>
        </div>

        <template v-for="(m, i) in messaggi">
          <div :key="'m' + i" :class="['chat-msg', m.cliente ? 'cliente' : 'bot']">
            <!-- formatta() toglie ogni markup prima di aggiungere elenchi e grassetti -->
            <!-- eslint-disable-next-line vue/no-v-html -->
            <div class="chat-fumetto" v-html="formatta(m.testo)"></div>
            <button v-if="m.prenota" type="button" class="chat-prenota" @click="prenota(m.prenota)">
              <fa :icon="['far', 'calendar-check']" /> {{ testi.CHAT_Prenota }}
            </button>
            <div class="chat-ora">{{ m.ora }}</div>
          </div>

          <!-- Schede delle tariffe: dati del calcolo del booking, non del testo del bot -->
          <div v-for="(sc, j) in m.schede || []" :key="'s' + i + '-' + j" class="chat-scheda">
            <div v-if="sc.foto" class="chat-scheda-foto" :style="{ backgroundImage: 'url(' + sc.foto + ')' }">
              <span v-if="sc.mq">{{ sc.camera }} · {{ sc.mq }} m²</span>
            </div>
            <div class="chat-scheda-testa">
              <div class="chat-scheda-camera">{{ sc.numero_camere > 1 ? sc.numero_camere + " × " : "" }}{{ sc.camera }}</div>
              <div class="chat-scheda-dati">{{ periodo(sc) }}</div>
            </div>
            <div v-for="(r, k) in sc.righe" :key="k" class="chat-riga">
              <div class="chat-riga-testo">
                <div class="chat-riga-trattamento">{{ r.trattamento }}</div>
                <div class="chat-riga-tariffa">
                  {{ r.tariffa }}
                  <button
                    v-if="r.cancellazione"
                    type="button"
                    class="chat-info"
                    :title="testi.CHAT_Cancellazione"
                    :aria-expanded="aperte[i + '-' + j + '-' + k] ? 'true' : 'false'"
                    @click="apriCondizioni(i + '-' + j + '-' + k)"
                  >
                    <fa :icon="['fas', 'info-circle']" />
                  </button>
                  <span v-if="r.rimaste > 0 && r.rimaste <= ULTIME" class="chat-ultime">{{ (testi.CHAT_Ultime || "").replace("%{n}", r.rimaste) }}</span>
                </div>
              </div>
              <div class="chat-riga-prezzo">
                <div class="chat-prezzo">{{ r.prezzo }}</div>
                <div v-if="r.totale" class="chat-riga-nota">{{ testi.CHAT_PerCamera }} · {{ testi.CHAT_Totale }} {{ r.totale }}</div>
                <button type="button" class="chat-riga-prenota" @click="prenota(r.prenota)">{{ testi.CHAT_PrenotaRiga }} <fa :icon="['fas', 'chevron-right']" /></button>
              </div>
              <!-- a tutta larghezza sotto la riga -->
              <div v-if="aperte[i + '-' + j + '-' + k]" class="chat-condizioni">
                <b>{{ testi.CHAT_Cancellazione }}</b>
                {{ r.cancellazione }}
              </div>
            </div>
          </div>

          <!-- date vicine: un tocco e il bot verifica quel periodo -->
          <div v-if="m.periodi && m.periodi.length" :key="'p' + i" class="chat-periodi">
            <button v-for="(pe, j) in m.periodi" :key="j" type="button" class="chat-periodo" :disabled="attesa" @click="chiediPeriodo(pe)">
              <b>{{ pe.dataarrivo.slice(0, 5) }} – {{ pe.datapartenza.slice(0, 5) }}</b>
              <small>{{ pe.notti }} {{ pe.notti === 1 ? testi.CHAT_Notte : testi.CHAT_Notti }} · {{ testi.CHAT_Da }} {{ pe.da }}</small>
            </button>
          </div>

          <!-- telefono ed email quando il bot non sa o non ha potuto rispondere -->
          <div v-if="m.contatti && (m.contatti.telefono || m.contatti.email)" :key="'c' + i" class="chat-contatti">
            <div class="chat-contatti-titolo">{{ (testi.CHAT_Contatta || "").replace("%{hotel}", m.contatti.nome || $hotel.ragsoc || "") }}</div>
            <div v-if="m.contatti.telefono" class="chat-contatto">
              <a class="chat-contatto-voce" :href="'tel:' + m.contatti.telefono.replace(/[^0-9+]/g, '')">
                <span class="chat-tondo"><fa :icon="['fas', 'phone']" /></span>
                <span><b>{{ testi.CHAT_Chiama }}</b><small>{{ m.contatti.telefono }}</small></span>
              </a>
              <button type="button" class="chat-copia" @click="copia(m.contatti.telefono, 't' + i)">{{ copiato === "t" + i ? testi.CHAT_Copiato : testi.CHAT_Copia }}</button>
            </div>
            <div v-if="m.contatti.email" class="chat-contatto">
              <a class="chat-contatto-voce" :href="'mailto:' + m.contatti.email">
                <span class="chat-tondo"><fa :icon="['fas', 'envelope']" /></span>
                <span><b>{{ testi.CHAT_ScriviEmail }}</b><small>{{ m.contatti.email }}</small></span>
              </a>
              <button type="button" class="chat-copia" @click="copia(m.contatti.email, 'e' + i)">{{ copiato === "e" + i ? testi.CHAT_Copiato : testi.CHAT_Copia }}</button>
            </div>
          </div>
        </template>

        <!-- attesa: per le domande con date si vedono le fasi e una scheda vuota -->
        <div v-if="attesa && attesaDate" class="chat-attesa-fasi">
          <div class="chat-fase fatta"><i></i>{{ testi.CHAT_Fase1 }}</div>
          <div v-if="faseAttesa > 1" class="chat-fase"><i></i>{{ testi.CHAT_Fase2 }}</div>
          <div class="chat-scheletro"><span style="width: 45%"></span><span style="width: 80%"></span><span style="width: 62%"></span></div>
        </div>
        <div v-else-if="attesa" class="chat-msg bot">
          <div class="chat-fumetto chat-attesa">{{ testi.CHAT_Scrive }} <span class="chat-puntini"><i></i><i></i><i></i></span></div>
        </div>
      </div>

      <form class="chat-scrivi" @submit.prevent="invia">
        <textarea
          ref="campo"
          v-model="testo"
          rows="1"
          maxlength="500"
          :placeholder="testi.CHAT_Scrivi"
          :disabled="attesa"
          @keydown.enter.exact.prevent="invia"
        ></textarea>
        <button type="submit" class="chat-invia" :title="testi.CHAT_Invia" :disabled="attesa || !testo.trim()"><fa :icon="['fas', 'paper-plane']" /></button>
      </form>
    </div>
  </div>
</template>

<script>
import apiService from "../services/api.js";

/** Chiave di sessionStorage: l'invito accanto al pulsante compare una volta per visita */
const CHIAVE_INVITO = "cybchat-invito";

/**
 * Chat del booking: l'assistente risponde alle domande sulla struttura e
 * verifica la disponibilità (BE_chat). Compare solo se la struttura l'ha
 * attivata. La conversazione vive finché la pagina è aperta: nel browser non
 * resta niente (solo il segno che l'invito è già stato mostrato).
 *
 * Le tariffe arrivano come schede: il bot sceglie quali mostrare, prezzi e
 * nomi vengono dal calcolo del booking. "Prenota" su una riga porta nella
 * ricerca con date, camere e ospiti e seleziona quella tariffa
 * ($store.chatPrenota, letto da camere.vue).
 */
export default {
  name: "CybChat",
  data() {
    return {
      attiva: false,
      aperta: false,
      invito: false,
      avvisoAperto: false,
      privacy: "",
      privacyAperta: false,
      testi: {},
      messaggi: [],
      testo: "",
      attesa: false,
      // la domanda in attesa parla di date: si mostrano le fasi della verifica
      attesaDate: false,
      faseAttesa: 1,
      conversazione: "",
      // condizioni di cancellazione aperte, per riga
      aperte: {},
      copiato: "",
      // risposte arrivate a chat chiusa
      nonLetti: 0,
      anteprima: "",
      ULTIME: 2,
      // telefono o tablet: niente tastiera aperta da sola, chat sopra la tastiera
      touch: typeof window !== "undefined" && !!window.matchMedia && window.matchMedia("(hover: none) and (pointer: coarse)").matches,
      // parte dello schermo visibile sopra la tastiera (visualViewport), solo a chat aperta su telefono
      areaVisibile: null,
      // overflow della pagina prima di aprire la chat, da rimettere alla chiusura
      scorrimentoPagina: null
    };
  },
  computed: {
    struttura() {
      // idlang: l'informativa privacy arriva nella lingua scelta
      return { db: this.$store.db, idhotel: this.$store.idhotel, lang: (this.$store.lang || "ita").toLowerCase(), idlang: this.$store.idlang || "" };
    },
    // Niente chat nelle pagine finali e in quelle del ristorante.
    visibilePagina() {
      const p = this.$route.path || "";
      return !p.startsWith("/ristorante") && !p.startsWith("/grazie") && !p.startsWith("/errore");
    },
    iniziali() {
      const parole = String(this.$hotel.ragsoc || "").replace(/^(hotel|albergo|b&b)\s+/i, "").split(/\s+/).filter(Boolean);
      return parole.slice(0, 2).map((p) => p[0].toUpperCase()).join("") || "?";
    },
    // A tutto schermo (telefono) la chat occupa solo la parte sopra la tastiera:
    // senza, il browser sposta la pagina e l'intestazione esce dallo schermo.
    stileFinestra() {
      if (!this.areaVisibile || window.innerWidth >= 576) {
        return {};
      }
      return { top: this.areaVisibile.top + "px", height: this.areaVisibile.height + "px", bottom: "auto" };
    },
    rapide() {
      return ["CHAT_D1", "CHAT_D2", "CHAT_D3", "CHAT_D4"].map((k) => this.testi[k]).filter((t) => t && !t.startsWith("CHAT_"));
    }
  },
  watch: {
    aperta(aperta) {
      if (aperta) {
        this.bloccaPagina();
      } else {
        this.sbloccaPagina();
      }
    },
    // l'altezza segue il testo, anche quando cambia da codice (invio, domande rapide)
    testo() {
      this.$nextTick(this.adatta);
    },
    struttura: {
      immediate: true,
      handler(s) {
        if (!s.db || !s.idhotel) {
          return;
        }
        apiService
          .get("BE_chat/" + s.db + "/" + s.idhotel + "/" + s.lang + "/" + s.idlang)
          .then((resp) => {
            this.attiva = !!resp.attiva;
            this.testi = resp.testi || {};
            this.privacy = resp.privacy || "";
            if (this.attiva) {
              this.preparaInvito();
            }
          })
          .catch(() => {
            this.attiva = false;
          });
      }
    }
  },
  beforeDestroy() {
    this.sbloccaPagina();
  },
  methods: {
    apri() {
      this.aperta = true;
      this.nonLetti = 0;
      this.chiudiInvito();
      this.$nextTick(() => {
        this.scorri();
        // su telefono il focus aprirebbe la tastiera e coprirebbe mezza chat:
        // la tastiera si apre quando il cliente tocca il campo
        if (this.$refs.campo && !this.touch) {
          this.$refs.campo.focus();
        }
      });
    },
    // ___________________ TELEFONO: TASTIERA E PAGINA ___________________
    /** Area visibile sopra la tastiera; i messaggi restano in fondo. */
    seguiSchermo() {
      const vv = window.visualViewport;
      if (!vv) {
        return;
      }
      this.areaVisibile = { top: Math.round(vv.offsetTop), height: Math.round(vv.height) };
      this.scorri();
    },
    /** A chat aperta su telefono la pagina sotto non scorre e la chat segue la tastiera. */
    bloccaPagina() {
      if (window.innerWidth >= 576) {
        return;
      }
      const main = document.querySelector("#app.main") || document.querySelector(".main");
      this.scorrimentoPagina = { html: document.documentElement.style.overflow, body: document.body.style.overflow, main: main ? main.style.overflow : "" };
      document.documentElement.style.overflow = "hidden";
      document.body.style.overflow = "hidden";
      if (main) {
        main.style.overflow = "hidden";
      }
      if (window.visualViewport) {
        window.visualViewport.addEventListener("resize", this.seguiSchermo);
        window.visualViewport.addEventListener("scroll", this.seguiSchermo);
        this.seguiSchermo();
      }
    },
    sbloccaPagina() {
      if (window.visualViewport) {
        window.visualViewport.removeEventListener("resize", this.seguiSchermo);
        window.visualViewport.removeEventListener("scroll", this.seguiSchermo);
      }
      this.areaVisibile = null;
      if (this.scorrimentoPagina) {
        const main = document.querySelector("#app.main") || document.querySelector(".main");
        document.documentElement.style.overflow = this.scorrimentoPagina.html;
        document.body.style.overflow = this.scorrimentoPagina.body;
        if (main) {
          main.style.overflow = this.scorrimentoPagina.main;
        }
        this.scorrimentoPagina = null;
      }
    },
    nuova() {
      this.messaggi = [];
      this.conversazione = "";
      this.testo = "";
    },
    /** Altezza del campo secondo il testo, fino al massimo del CSS. */
    adatta() {
      const el = this.$refs.campo;
      if (!el) {
        return;
      }
      el.style.height = "auto";
      const massimo = parseInt(getComputedStyle(el).maxHeight, 10) || 104;
      // + 2: il bordo, che scrollHeight non conta
      el.style.height = Math.max(40, Math.min(el.scrollHeight + 2, massimo)) + "px";
      el.style.overflowY = el.scrollHeight + 2 > massimo ? "auto" : "hidden";
    },
    chiedi(domanda) {
      this.testo = domanda;
      this.invia();
    },
    chiediPeriodo(pe) {
      this.chiedi((this.testi.CHAT_VerificaPeriodo || "%{dal} - %{al}").replace("%{dal}", pe.dataarrivo).replace("%{al}", pe.datapartenza));
    },
    apriCondizioni(chiave) {
      this.$set(this.aperte, chiave, !this.aperte[chiave]);
    },
    copia(testo, chiave) {
      const fatto = () => {
        this.copiato = chiave;
        setTimeout(() => (this.copiato = ""), 2000);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(testo).then(fatto, () => {});
      }
    },
    /** La domanda parla di date? (numeri o mesi nelle lingue del booking) */
    parlaDiDate(testo) {
      return /\d|genn|febb|marz|april|magg|giugn|lugl|agost|sett|ottob|novem|dicem|jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec|mai|juin|juil|août|okt|dez|ene|ago|dic/i.test(testo);
    },
    invia() {
      const testo = this.testo.trim();
      if (!testo || this.attesa) {
        return;
      }
      const s = this.struttura;
      this.messaggi.push({ cliente: true, testo: testo, ora: this.ora() });
      this.testo = "";
      this.attesa = true;
      this.attesaDate = this.parlaDiDate(testo);
      this.faseAttesa = 1;
      // le fasi seguono il tempo, non il server: dopo un attimo si passa ai prezzi
      const fase = setTimeout(() => (this.faseAttesa = 2), 1200);
      this.scorri();
      apiService
        .post("BE_chat/messaggio/" + s.db + "/" + s.idhotel + "/" + s.lang + "/" + (this.$store.idlang || ""), { conversazione: this.conversazione, testo: testo })
        .then((resp) => {
          this.conversazione = resp.conversazione || this.conversazione;
          this.messaggi.push({
            cliente: false,
            testo: resp.risposta || "",
            prenota: resp.prenota || null,
            schede: resp.schede || [],
            periodi: resp.periodi || [],
            contatti: resp.contatti || null,
            ora: this.ora()
          });
          this.segnaNonLetto(resp.risposta || "");
        })
        .catch(() => {
          this.messaggi.push({ cliente: false, testo: this.testi.CHAT_Errore || "", ora: this.ora() });
          this.segnaNonLetto(this.testi.CHAT_Errore || "");
        })
        .finally(() => {
          clearTimeout(fase);
          this.attesa = false;
          this.scorri();
          // il cursore torna nel campo solo dove non apre una tastiera
          this.$nextTick(() => this.$refs.campo && !this.touch && this.$refs.campo.focus());
        });
    },
    /** Risposta arrivata con la chat chiusa: anteprima e contatore sul pulsante. */
    segnaNonLetto(testo) {
      if (!this.aperta) {
        this.nonLetti++;
        const riga = String(testo).replace(/\s+/g, " ").trim();
        this.anteprima = riga.length > 90 ? riga.slice(0, 89) + "…" : riga;
      }
    },
    prenota(p) {
      // oggetto nuovo a ogni clic: camere.vue lo osserva
      this.$store.chatPrenota = {
        ...p,
        ospiti: (p.ospiti || []).map((c) => ({ adulti: c.adulti, bambini: [...(c.bambini || [])] })),
        scelta: p.scelta ? { ...p.scelta, stanze: [...(p.scelta.stanze || [])] } : null,
        // etichetta che la ricerca mostra per qualche secondo
        etichetta: this.testi.CHAT_DallaChat || "",
        quando: Date.now()
      };
      if (this.$route.name !== "camere") {
        this.$router.push({ path: "/", query: { RPC_db: this.$store.db, idhotel: this.$store.idhotel, lan: this.$store.lang } });
      }
      // la chat copre le tariffe: si chiude (la conversazione resta) per mostrare le camere
      this.aperta = false;
    },
    // ____________________________ INVITO ____________________________
    preparaInvito() {
      let visto = false;
      try {
        visto = window.sessionStorage.getItem(CHIAVE_INVITO) === "1";
      } catch (e) {
        visto = false;
      }
      if (!visto) {
        setTimeout(() => {
          this.invito = !this.aperta && !this.messaggi.length;
        }, 6000);
      }
    },
    chiudiInvito() {
      this.invito = false;
      try {
        window.sessionStorage.setItem(CHIAVE_INVITO, "1");
      } catch (e) {
        // senza sessionStorage l'invito puo' ricomparire alla prossima pagina: pazienza
      }
    },
    // ____________________________ TESTO ____________________________
    /**
     * Testo del bot in HTML: prima si toglie ogni markup, poi le righe che
     * iniziano con "-" diventano un elenco e gli importi in euro vanno in
     * grassetto.
     */
    formatta(testo) {
      const sicuro = String(testo || "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
      const evidenzia = (riga) => riga.replace(/(€\s?\d[\d.]*(?:,\d{2})?|\d[\d.]*(?:,\d{2})?\s?€)/g, "<b>$1</b>");
      let html = "";
      let elenco = false;
      sicuro.split("\n").forEach((riga) => {
        const voce = riga.match(/^\s*[-•]\s+(.*)$/);
        if (voce) {
          html += (elenco ? "" : "<ul>") + "<li>" + evidenzia(voce[1]) + "</li>";
          elenco = true;
          return;
        }
        if (elenco) {
          html += "</ul>";
          elenco = false;
        }
        html += evidenzia(riga) + "<br>";
      });
      if (elenco) {
        html += "</ul>";
      }
      return html.replace(/(<br>)+$/, "");
    },
    periodo(sc) {
      const t = this.testi;
      const giorno = (d) => String(d || "").slice(0, 5);
      const parti = [giorno(sc.dataarrivo) + " – " + giorno(sc.datapartenza), sc.notti + " " + (sc.notti === 1 ? t.CHAT_Notte : t.CHAT_Notti)];
      parti.push(sc.adulti + " " + (sc.adulti === 1 ? t.CHAT_Adulto : t.CHAT_Adulti) + (sc.numero_camere > 1 ? " / " + t.CHAT_PerCamera : ""));
      if (sc.bambini && sc.bambini.length) {
        parti.push(sc.bambini.length + " " + (sc.bambini.length === 1 ? t.CHAT_Bambino : t.CHAT_Bambini) + " (" + sc.bambini.join(", ") + ")");
      }
      return parti.join(" · ");
    },
    ora() {
      const d = new Date();
      return String(d.getHours()).padStart(2, "0") + ":" + String(d.getMinutes()).padStart(2, "0");
    },
    scorri() {
      this.$nextTick(() => {
        const el = this.$refs.messaggi;
        if (el) {
          el.scrollTop = el.scrollHeight;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
// Colori: quello dell'hotel (--chat-color) per testata, messaggi del cliente e
// pulsanti; il resto neutro, perche' la chat sta sopra qualsiasi sfondo.
$testo: #232a36;
$tenue: #6c7382;
$linea: #e2e5ea;
$fondo: #f5f6f8;

.cyb-chat {
  position: fixed;
  right: 16px;
  bottom: 16px;
  z-index: 1050;
  text-align: left;
  font-size: 14px;
  color: $testo;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 10px;
}
.chat-apri {
  display: flex;
  align-items: center;
  gap: 8px;
  border: none;
  border-radius: 28px;
  padding: 12px 18px;
  background: var(--chat-color);
  color: var(--chat-fore);
  font-weight: 500;
  cursor: pointer;
  svg {
    font-size: 20px;
  }
}
// ______________________ INVITO ______________________
.chat-invito {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  max-width: 260px;
  background: #ffffff;
  border: 1px solid $linea;
  border-radius: 12px 12px 4px 12px;
  padding: 10px 8px 10px 12px;
  animation: chat-entra 0.25s ease-out;
}
.chat-invito-testo {
  border: none;
  background: transparent;
  padding: 0;
  text-align: left;
  font-size: 13px;
  line-height: 1.4;
  color: $testo;
  cursor: pointer;
}
.chat-invito-chiudi {
  border: none;
  background: transparent;
  color: $tenue;
  padding: 0 2px;
  font-size: 12px;
  cursor: pointer;
}
@keyframes chat-entra {
  from {
    opacity: 0;
    transform: translateY(6px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
// ______________________ FINESTRA ______________________
.chat-finestra {
  display: flex;
  flex-direction: column;
  width: 380px;
  height: min(600px, calc(100vh - 32px));
  background: #ffffff;
  border-radius: 12px;
  overflow: hidden;
}
.chat-testata {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  background: var(--chat-color);
  color: var(--chat-fore);
}
.chat-avatar {
  flex: none;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #ffffff;
  color: var(--chat-color);
  display: grid;
  place-items: center;
  font-weight: 700;
  font-size: 13px;
  overflow: hidden;
  // i loghi sono spesso larghi: niente cerchio, un riquadro chiaro
  &.con-logo {
    width: auto;
    max-width: 76px;
    border-radius: 8px;
    padding: 3px 6px;
  }
  img {
    max-width: 64px;
    max-height: 30px;
    object-fit: contain;
  }
}
.chat-titolo {
  flex: 1;
  min-width: 0;
  line-height: 1.25;
}
.chat-nome {
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.chat-stato {
  font-size: 11.5px;
  opacity: 0.9;
  display: flex;
  align-items: center;
  gap: 5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.chat-puntino {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #7fe3a5;
  display: inline-block;
}
.chat-icona {
  border: none;
  background: transparent;
  color: inherit;
  padding: 2px 6px;
  cursor: pointer;
  opacity: 0.85;
  &:hover,
  &:focus-visible {
    opacity: 1;
  }
}
.chat-messaggi {
  flex: 1;
  overflow-y: auto;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  background: $fondo;
}
// Nella colonna che scorre nessun elemento si deve restringere: le schede
// (overflow hidden) verrebbero schiacciate invece di far scorrere la colonna.
.chat-messaggi > * {
  flex-shrink: 0;
}
.chat-avviso {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  font-size: 11px;
  color: $tenue;
  text-align: center;
  line-height: 1.35;
  svg {
    margin-right: 2px;
  }
}
.chat-avviso-testo {
  margin: 0;
}
.chat-avviso-link {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 6px;
}
.chat-link {
  display: inline-block;
  width: auto;
  border: none;
  background: transparent;
  padding: 0;
  font-size: 11px;
  color: $tenue;
  text-decoration: underline;
  cursor: pointer;
}
.chat-privacy {
  max-height: 220px;
  overflow-y: auto;
  text-align: left;
  ::v-deep p {
    margin: 0 0 6px;
  }
}
.chat-avviso-intero {
  font-size: 11px;
  color: $tenue;
  line-height: 1.4;
  padding: 6px 8px;
  border-radius: 6px;
  background: #eceef1;
}
// ______________________ MESSAGGI ______________________
.chat-msg {
  display: flex;
  flex-direction: column;
  max-width: 88%;
  &.cliente {
    align-self: flex-end;
    align-items: flex-end;
    .chat-fumetto {
      background: var(--chat-color);
      color: var(--chat-fore);
      border-bottom-right-radius: 4px;
    }
  }
  &.bot {
    align-self: flex-start;
    .chat-fumetto {
      background: #ffffff;
      border: 1px solid $linea;
      border-bottom-left-radius: 4px;
    }
  }
}
.chat-fumetto {
  padding: 8px 12px;
  border-radius: 14px;
  overflow-wrap: anywhere;
  line-height: 1.42;
  ::v-deep ul {
    margin: 4px 0;
    padding-left: 18px;
  }
  ::v-deep li {
    margin: 2px 0;
  }
  ::v-deep b {
    font-weight: 600;
  }
}
.chat-ora {
  font-size: 10px;
  color: $tenue;
  margin-top: 2px;
  padding-inline: 4px;
}
.chat-rapide {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.chat-rapida {
  border: 1px solid var(--chat-color);
  color: var(--chat-color);
  background: #ffffff;
  border-radius: 16px;
  padding: 5px 11px;
  font-size: 12.5px;
  cursor: pointer;
  &:hover,
  &:focus-visible {
    background: var(--chat-color);
    color: var(--chat-fore);
  }
}
.chat-prenota {
  margin-top: 6px;
  border: none;
  border-radius: 18px;
  padding: 6px 14px;
  background: var(--chat-color);
  color: var(--chat-fore);
  font-size: 13px;
  cursor: pointer;
}
// ______________________ SCHEDE TARIFFE ______________________
.chat-scheda {
  background: #ffffff;
  border: 1px solid $linea;
  border-radius: 12px;
  overflow: hidden;
  width: 100%;
}
.chat-scheda-testa {
  padding: 9px 12px 8px;
  border-bottom: 1px solid $linea;
}
.chat-scheda-camera {
  font-weight: 600;
}
.chat-scheda-dati {
  font-size: 11.5px;
  color: $tenue;
}
.chat-riga {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  padding: 9px 12px;
  border-bottom: 1px solid $linea;
  &:last-child {
    border-bottom: none;
  }
}
.chat-riga-testo {
  flex: 1;
  min-width: 0;
}
.chat-riga-trattamento {
  font-weight: 500;
}
.chat-riga-tariffa {
  font-size: 11.5px;
  color: $tenue;
}
.chat-riga-prezzo {
  flex: none;
  text-align: right;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 3px;
}
.chat-prezzo {
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}
.chat-riga-nota {
  font-size: 10.5px;
  color: $tenue;
}
.chat-riga-prenota {
  border: none;
  border-radius: 14px;
  padding: 3px 10px;
  background: var(--chat-color);
  color: var(--chat-fore);
  font-size: 12px;
  cursor: pointer;
  svg {
    font-size: 9px;
    margin-left: 2px;
  }
}
// ______________________ FOTO, ULTIME, CONDIZIONI ______________________
.chat-scheda-foto {
  height: 96px;
  background-size: cover;
  background-position: center;
  background-color: #e9ebef;
  position: relative;
  span {
    position: absolute;
    left: 10px;
    bottom: 8px;
    background: rgba(15, 18, 24, 0.62);
    color: #ffffff;
    font-size: 11px;
    padding: 2px 7px;
    border-radius: 4px;
  }
}
.chat-info {
  border: none;
  background: transparent;
  padding: 0 2px;
  margin-left: 2px;
  color: $tenue;
  font-size: 13px;
  line-height: 1;
  cursor: pointer;
  vertical-align: -1px;
  &:hover,
  &:focus-visible,
  &[aria-expanded="true"] {
    color: var(--chat-color);
  }
}
.chat-ultime {
  display: inline-block;
  margin-left: 4px;
  background: #fdeee3;
  color: #b4531c;
  font-size: 10.5px;
  padding: 1px 6px;
  border-radius: 4px;
}
.chat-condizioni {
  flex-basis: 100%;
  font-size: 11.5px;
  line-height: 1.4;
  color: $testo;
  background: $fondo;
  border-radius: 6px;
  padding: 6px 8px;
  b {
    display: block;
    font-weight: 600;
    margin-bottom: 2px;
  }
}
// ______________________ PERIODI ______________________
.chat-periodi {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.chat-periodo {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1px;
  border: 1px solid var(--chat-color);
  background: #ffffff;
  border-radius: 10px;
  padding: 6px 10px;
  cursor: pointer;
  color: var(--chat-color);
  text-align: left;
  b {
    font-weight: 600;
    font-size: 13px;
  }
  small {
    color: $tenue;
    font-size: 11px;
  }
  &:hover,
  &:focus-visible {
    border-width: 2px;
    padding: 5px 9px;
  }
  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
}
// ______________________ CONTATTI ______________________
.chat-contatti {
  background: #ffffff;
  border: 1px solid $linea;
  border-radius: 12px;
  padding: 10px 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.chat-contatti-titolo {
  font-size: 12px;
  color: $tenue;
}
.chat-contatto {
  display: flex;
  align-items: center;
  gap: 8px;
}
.chat-contatto-voce {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 10px;
  color: $testo;
  text-decoration: none;
  b {
    display: block;
    font-weight: 500;
    font-size: 13px;
  }
  small {
    display: block;
    color: $tenue;
    font-size: 11.5px;
    overflow-wrap: anywhere;
  }
}
.chat-tondo {
  flex: none;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: var(--chat-color);
  color: var(--chat-fore);
  display: grid;
  place-items: center;
  font-size: 12px;
}
.chat-copia {
  flex: none;
  border: 1px solid $linea;
  background: #ffffff;
  border-radius: 6px;
  padding: 2px 8px;
  font-size: 11px;
  color: var(--chat-color);
  cursor: pointer;
}
// ______________________ NON LETTI ______________________
.chat-nonletto {
  flex-direction: column;
  gap: 2px;
  text-align: left;
  cursor: pointer;
  font-size: 12.5px;
  line-height: 1.35;
  color: $testo;
  b {
    font-weight: 600;
  }
}
.chat-apri {
  position: relative;
}
.chat-contatore {
  position: absolute;
  top: -6px;
  right: -4px;
  min-width: 20px;
  height: 20px;
  border-radius: 10px;
  background: #d1372c;
  color: #ffffff;
  font-size: 11px;
  font-weight: 700;
  display: grid;
  place-items: center;
  border: 2px solid #ffffff;
}
// ______________________ ATTESA ______________________
.chat-attesa-fasi {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.chat-fase {
  font-size: 12px;
  color: $tenue;
  display: flex;
  align-items: center;
  gap: 6px;
  animation: chat-entra 0.25s ease-out;
  i {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    border: 2px solid var(--chat-color);
    border-right-color: transparent;
    animation: chat-gira 0.8s linear infinite;
  }
  &.fatta i {
    border: 0;
    background: var(--chat-color);
    animation: none;
  }
}
.chat-scheletro {
  background: #ffffff;
  border: 1px solid $linea;
  border-radius: 12px;
  padding: 10px 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  span {
    display: block;
    height: 9px;
    border-radius: 5px;
    background: linear-gradient(90deg, #eceef1 0%, #f6f7f9 50%, #eceef1 100%);
    background-size: 200% 100%;
    animation: chat-luce 1.2s ease-in-out infinite;
  }
}
@keyframes chat-gira {
  to {
    transform: rotate(360deg);
  }
}
@keyframes chat-luce {
  from {
    background-position: 100% 0;
  }
  to {
    background-position: -100% 0;
  }
}
.chat-attesa {
  color: $tenue;
  font-style: italic;
}
.chat-puntini i {
  display: inline-block;
  width: 4px;
  height: 4px;
  margin-left: 2px;
  border-radius: 50%;
  background: #9a9a9a;
  animation: chat-punto 1s infinite ease-in-out;
  &:nth-child(2) {
    animation-delay: 0.15s;
  }
  &:nth-child(3) {
    animation-delay: 0.3s;
  }
}
@keyframes chat-punto {
  0%,
  80%,
  100% {
    opacity: 0.2;
  }
  40% {
    opacity: 1;
  }
}
@media (prefers-reduced-motion: reduce) {
  .chat-invito,
  .chat-puntini i,
  .chat-fase,
  .chat-fase i,
  .chat-scheletro span {
    animation: none;
  }
}
// ______________________ SCRITTURA ______________________
.chat-scrivi {
  display: flex;
  align-items: flex-end;
  gap: 8px;
  padding: 10px;
  border-top: 1px solid $linea;
  // Cresce con il testo fino a 4 righe (adatta()); oltre scorre, con una barra sottile.
  textarea {
    flex: 1;
    min-width: 0;
    box-sizing: border-box;
    resize: none;
    border: 1px solid #d5d8dc;
    border-radius: 19px;
    padding: 9px 14px;
    height: 40px;
    max-height: 104px;
    font: inherit;
    font-size: 14px;
    line-height: 20px;
    color: $testo;
    overflow-y: hidden;
    outline: none;
    scrollbar-width: thin;
    &::-webkit-scrollbar {
      width: 6px;
    }
    &::-webkit-scrollbar-button {
      display: none;
    }
    &::-webkit-scrollbar-thumb {
      background: #c9cdd3;
      border-radius: 3px;
    }
    &:focus {
      border-color: var(--chat-color);
    }
    &:disabled {
      background: $fondo;
    }
  }
}
.chat-invia {
  flex: none;
  border: none;
  width: 40px;
  height: 40px;
  padding: 0;
  border-radius: 50%;
  background: var(--chat-color);
  color: var(--chat-fore);
  display: grid;
  place-items: center;
  font-size: 15px;
  cursor: pointer;
  // l'aereo di carta pende verso destra e in alto: lo si riporta al centro a occhio
  svg {
    transform: translate(-1px, 1px);
  }
  &:disabled {
    opacity: 0.35;
    cursor: default;
  }
}
// Telefono: la chat occupa lo schermo, il pulsante resta compatto.
@media (max-width: 575px) {
  .cyb-chat {
    right: 12px;
    bottom: 12px;
  }
  .chat-apri-testo {
    display: none;
  }
  .chat-apri {
    padding: 14px;
  }
  .chat-invito {
    max-width: 220px;
  }
  .chat-finestra {
    position: fixed;
    inset: 0;
    width: 100%;
    height: 100%;
    border-radius: 0;
  }
}
</style>
